import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["breakpoints", "buttonSize", "defaultDevice", "extraBreakpoints", "iconButtonStyles", "inputLabelText", "onBreakpointSelect", "previewWidth"];
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Text } from 'foundations-components/components/Text';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { filterProps } from 'foundations-components/utils/filterProps';
import EPDeviceSelectButton from 'editor-components/preview/EPDeviceSelectButton';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InputLabel = styled.label.withConfig({
  displayName: "EPBreakpointControls__InputLabel"
})(({
  theme
}) => ({
  display: 'inline-flex',
  alignItems: 'center',
  marginInlineStart: theme.space['200'],
  position: 'absolute'
}));
const EPBreakpointControls = _ref => {
  let {
      breakpoints,
      buttonSize = 'medium',
      defaultDevice,
      extraBreakpoints = [],
      iconButtonStyles = {
        paddingBlock: '200'
      },
      inputLabelText = 'W',
      onBreakpointSelect,
      previewWidth
    } = _ref,
    spaceProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    tokenProps
  } = filterProps(spaceProps);
  if (!breakpoints || breakpoints.length === 0) {
    return null;
  }
  function handleBreakpointSelect(e) {
    if (onBreakpointSelect) {
      onBreakpointSelect(e);
    }
  }
  const fallbackDefaultDevice = typeof breakpoints[0] === 'object' ? breakpoints[0].name : breakpoints[0];
  return /*#__PURE__*/_jsxs(View, Object.assign({}, tokenProps, {
    position: "relative",
    children: [/*#__PURE__*/_jsx(EPDeviceSelectButton, {
      buttonSize: buttonSize,
      defaultValue: defaultDevice || fallbackDefaultDevice,
      devices: breakpoints,
      dropdownStyles: {
        paddingBlock: '200'
      },
      extraDevices: extraBreakpoints,
      iconButtonStyles: iconButtonStyles,
      onChange: handleBreakpointSelect
    }), previewWidth && /*#__PURE__*/_jsxs(InputLabel, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "span",
        typography: "body-200",
        children: inputLabelText
      }), /*#__PURE__*/_jsx(TextInput, {
        blockSize: "36px",
        inlineSize: "75px",
        marginInlineStart: "200",
        readOnly: true,
        value: previewWidth
      })]
    })]
  }));
};
EPBreakpointControls.propTypes = {
  breakpoints: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape({
    name: PropTypes.string.isRequired,
    tooltip: PropTypes.node,
    icon: PropTypes.string
  }), PropTypes.string])).isRequired,
  buttonSize: PropTypes.string,
  className: PropTypes.string,
  defaultDevice: PropTypes.string,
  deviceSelectClassName: PropTypes.string,
  inputLabelClassName: PropTypes.string,
  inputLabelText: PropTypes.node,
  inputLabelWrapperClassName: PropTypes.string,
  showBreakpointWidthField: PropTypes.bool,
  onBreakpointSelect: PropTypes.func,
  previewWidth: PropTypes.string
};
export default EPBreakpointControls;